import { Separator } from "@/components/ui/separator";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";

export const SiteHeader = ({
    title,
    description,
    primaryAction,
}: {
    title: string;
    description?: string;
    primaryAction?: React.ReactNode;
}) => {
    const { state } = useSidebar();

    return (
        <header
            className={`fixed left-0 right-0 top-0 z-50 flex h-16 items-center border-b bg-admin-background px-4 transition-[left] duration-200 ease-linear lg:px-6 ${
                state === "collapsed"
                    ? "md:left-[var(--sidebar-width-icon)]"
                    : "md:left-[var(--sidebar-width)]"
            }`}
        >
            <SidebarTrigger className="text-admin-sidebar-foreground" />
            <Separator
                orientation="vertical"
                className="mx-3 h-4"
            />
            <div className="flex items-baseline gap-2">
                <h1 className="text-base font-medium text-admin-sidebar-foreground">
                    {title}
                </h1>
                {description && (
                    <p className="text-sm text-admin-sidebar-foreground">
                        {description}
                    </p>
                )}
            </div>
            {primaryAction && (
                <div className="ml-auto flex items-center gap-2">
                    {primaryAction}
                </div>
            )}
        </header>
    );
};
